import type { IAiModel, ModelSetting, ModelSettings } from 'src/types/base';
import { THINKING_EFFORT } from 'src/types/enum';

export const MODEL_SETTINGS_PREFERENCE_KEY = 'model_settings';

const isValidModelSetting = (value: unknown): value is ModelSetting =>
  !!value &&
  typeof value === 'object' &&
  Object.values(THINKING_EFFORT).includes((value as ModelSetting).effort);

export const parseModelSettings = (raw?: string): ModelSettings => {
  if (!raw) {
    return {};
  }

  let parsed: unknown;

  try {
    parsed = JSON.parse(raw);
  } catch {
    return {};
  }

  if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) {
    return {};
  }

  return Object.fromEntries(
    Object.entries(parsed).flatMap(([modelId, setting]) =>
      isValidModelSetting(setting)
        ? [[modelId, { effort: setting.effort }]]
        : []
    )
  );
};

//  Drops settings whose model is no longer configured
export const pruneModelSettings = (
  settings: ModelSettings,
  configuredModels?: IAiModel[]
): ModelSettings => {
  if (!configuredModels?.length) {
    return settings;
  }

  return Object.fromEntries(
    configuredModels.flatMap((model) =>
      settings[model.id] ? [[model.id, settings[model.id]]] : []
    )
  );
};
